import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/pt';
import 'moment/locale/sq';
import 'moment/locale/sr';
import 'moment/locale/tr';
import 'intl-pluralrules';

import deTranslations from './language/de/index';
import enTranslations from './language/en/index';
import srTranslations from './language/sr/index';

const de = { translation: deTranslations }
const en = { translation: enTranslations }
const sr = { translation: srTranslations }

const resources = {
  de, en, sr
}

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  //.use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: resources,
    fallbackLng: 'de',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
      format: function (value, format, lng = 'de') {
        if (value instanceof Date) {
          return moment(value).locale(lng).format(format);
        }
        return value;
      },
    },
    compatibilityJSON: 'v4',
    react: {
      useSuspense: false,
    },
  });
i18n.on('languageChanged', function (lng) {
  moment.locale(lng);
});

export default i18n;
